// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  EXPLOSION_BURN,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  explosionBurnKindForBlast,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import { EXTRAP_CAP_MS, tickInterpDelay } from "../net-jitter";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  pveBossDisplayName,
  pveAddDisplayName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  octIndex,
  warlockImage,
  warlockImageByOct,
  touchBossCast,
} from "../sprites";
import {
  AUDIO_CREDITS,
  CH,
  Sound,
  noise,
  tone,
} from "../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";

Game.prototype.playFX = function (f) {
    const k = f.k;
    if (k === "hit") {
      Sound.hit();
      this.spawnParticles(f.x, f.y, 9, "#ffd0a0", 150, 0.3, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 26, "#ffe0b0", { life: 0.25, width: 3 });
    }
    else if (k === "dmg") { this.spawnDmgPopup(f.x, f.y, f.v || 0, false); }
    else if (k === "dmgdot") { this.spawnDmgPopup(f.x, f.y, f.v || 0, true); }
    else if (k === "heal") { this.spawnHealPopup(f.x, f.y, f.v || 0); }
    else if (k === "blast") {
      const rr = f.v || 120;
      this.fireBurst(f.x, f.y, 30, 1.3);
      this.spawnShockwave(f.x, f.y, rr, "#ffb060", { life: 0.5, width: 7 });
      this.spawnShockwave(f.x, f.y, rr * 0.6, "#fff0d0", { life: 0.3, width: 4 });
      this.spawnFloorBurn(explosionBurnKindForBlast(rr), f.x, f.y, rr);
    }
    else if (k === "boom") {
      Sound.boom();
      this.fireBurst(f.x, f.y, 20, 1);
      this.spawnShockwave(f.x, f.y, 100, "#ff8a6a", { life: 0.4, width: 5 });
      this.spawnFloorBurn("projectile", f.x, f.y, 52);
    }
    else if (k === "fall") { Sound.fall(); this.spawnParticles(f.x, f.y, 14, "#c9c4ec", 100, 0.5, { kind: "glow" }); }
    else if (k === "shield") {
      Sound.block();
      this.spawnParticles(f.x, f.y, 12, "#9ec8ff", 90, 0.4, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 40, "#9ec8ff", { life: 0.3, width: 3 });
    }
    else if (k === "scourge") {
      Sound.castFor("scourge");
      this.fireBurst(f.x, f.y, 26, 1.2);
      this.spawnShockwave(f.x, f.y, 165, "#ff6a3a", { life: 0.5, width: 8 });
      this.spawnShockwave(f.x, f.y, 110, "#ffd0a0", { life: 0.32, width: 4 });
      this.spawnFloorBurn("scourge", f.x, f.y, EXPLOSION_BURN.scourge.r);
    }
    else if (k === "stickymineplant") {
      Sound.stickyMinePlant();
      this.spawnParticles(f.x, f.y, 8, "#ff5d3a", 90, 0.28, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 22, "#ff7a50", { life: 0.18, width: 2 });
    }
    else if (k === "stickyminedetonate") {
      Sound.castFor("scourge");
      this.fireBurst(f.x, f.y, 26, 1.2);
      this.spawnShockwave(f.x, f.y, 165, "#ff6a3a", { life: 0.5, width: 8 });
      this.spawnShockwave(f.x, f.y, 110, "#ffd0a0", { life: 0.32, width: 4 });
      this.spawnFloorBurn("scourge", f.x, f.y, EXPLOSION_BURN.scourge.r);
    }
    else if (k === "frostnova") {
      Sound.castFor("frostnova");
      const rr = f.v || 140;
      this.spawnParticles(f.x, f.y, 22, "#aef0ff", 200, 0.45, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, rr, "#9fe7ff", { life: 0.42, width: 5 });
      this.spawnShockwave(f.x, f.y, rr * 0.65, "#e8fcff", { life: 0.28, width: 3 });
    }
    else if (k === "radiantburst") {
      tone(220, 0.18, { type: "sawtooth", gain: 0.05, slideTo: 140, channel: CH.sfx });
      tone(440, 0.32, { type: "triangle", gain: 0.045, delay: 0.04, channel: CH.sfx });
      const rr = f.v || 200;
      this.spawnParticles(f.x, f.y, 28, "#ff8844", 220, 0.5, { kind: "glow" });
      this.spawnParticles(f.x, f.y, 16, "#ffd479", 160, 0.35, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, rr, "#ff6030", { life: 0.55, width: 8 });
      this.spawnShockwave(f.x, f.y, rr * 0.55, "#ffb060", { life: 0.35, width: 4 });
    }
    else if (k === "solar_flare") {
      tone(280, 0.2, { type: "sine", gain: 0.055, slideTo: 180, channel: CH.sfx });
      tone(520, 0.28, { type: "triangle", gain: 0.05, delay: 0.05, channel: CH.sfx });
      const rr = f.v || 240;
      this.spawnParticles(f.x, f.y, 32, "#ffd878", 240, 0.55, { kind: "glow" });
      this.spawnParticles(f.x, f.y, 18, "#ffc040", 180, 0.4, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, rr, "#ffb040", { life: 0.5, width: 7 });
      this.spawnShockwave(f.x, f.y, rr * 0.6, "#fff0c0", { life: 0.32, width: 4 });
    }
    else if (k === "sanctuary") {
      tone(520, 0.35, { type: "sine", gain: 0.05, slideTo: 880, channel: CH.sfx });
      tone(660, 0.45, { type: "triangle", gain: 0.04, delay: 0.08, channel: CH.sfx });
      const rr = f.v || 165;
      this.spawnParticles(f.x, f.y, 26, "#7ee8a0", 180, 0.55, { kind: "glow" });
      this.spawnParticles(f.x, f.y, 14, "#fff0a8", 140, 0.4, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, rr, "#7ee8a0", { life: 0.5, width: 8 });
      this.spawnShockwave(f.x, f.y, rr * 0.55, "#e8ffe0", { life: 0.32, width: 4 });
    }
    else if (k === "bloompod") {
      tone(480, 0.3, { type: "sine", gain: 0.05, slideTo: 720, channel: CH.sfx });
      tone(620, 0.4, { type: "triangle", gain: 0.04, delay: 0.06, channel: CH.sfx });
      this.commitBloomPodDetonate(f.x, f.y, f.v || 120);
    }
    else if (k === "seismicslam") {
      tone(90, 0.45, { type: "sawtooth", gain: 0.06, slideTo: 45, channel: CH.sfx });
      const rr = f.v || 200;
      this.spawnParticles(f.x, f.y, 24, "#c8a882", 180, 0.55, { kind: "glow" });
      this.spawnParticles(f.x, f.y, 14, "#8a7058", 120, 0.4, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, rr, "#b89870", { life: 0.5, width: 9 });
      this.spawnShockwave(f.x, f.y, rr * 0.55, "#e8d4b0", { life: 0.32, width: 4 });
    }
    else if (k === "bossfissurearm") {
      tone(110, 0.35, { type: "sawtooth", gain: 0.045, slideTo: 70, channel: CH.sfx });
      this.spawnShockwave(f.x, f.y, 98, "#6a5848", { life: 0.35, width: 3 });
    }
    else if (k === "bossfissurepop") {
      tone(80, 0.25, { type: "sawtooth", gain: 0.04, slideTo: 40, channel: CH.sfx });
      this.spawnParticles(f.x, f.y, 10, "#5a4838", 90, 0.35, { kind: "glow" });
    }
    else if (k === "bossenrage") {
      tone(70, 0.55, { type: "sawtooth", gain: 0.07, slideTo: 110, channel: CH.sfx });
      noise(0.5, { gain: 0.05, freq: 80, slideTo: 160, channel: CH.sfx });
      this.spawnShockwave(f.x, f.y, 140, "#ff6030", { life: 0.65, width: 10 });
      this.spawnShockwave(f.x, f.y, 90, "#ffb060", { life: 0.45, width: 5 });
      this.spawnParticles(f.x, f.y, 30, "#ff8040", 220, 0.6, { kind: "glow" });
    }
    else if (k === "charge") {
      tone(95, 0.35, { type: "sawtooth", gain: 0.055, slideTo: 55, channel: CH.sfx });
      this.spawnShockwave(f.x, f.y, 55, "#c8b898", { life: 0.28, width: 5 });
      if (f.x2 != null && f.y2 != null) {
        this.spawnBeam(f.x, f.y, f.x2, f.y2, "#c8b898", 6);
        this.spawnParticles(f.x, f.y, 10, "#a89070", 120, 0.35, { kind: "spark" });
        this.spawnParticles(f.x2, f.y2, 16, "#a89070", 160, 0.45, { kind: "spark" });
      }
    }
    else if (k === "swap_tether") {
      if (f.x2 != null && f.y2 != null) {
        this.spawnBeam(f.x, f.y, f.x2, f.y2, "#b080e8", 4);
        this.spawnParticles(f.x2, f.y2, 8, "#d0a0ff", 90, 0.35, { kind: "glow" });
      }
    }
    else if (k === "swap_charge") {
      const prog = clamp((f.v || 0) / 100, 0, 1);
      this.spawnShockwave(f.x, f.y, 50 + prog * 80, "#b080e8", { life: 0.35, width: 3 + prog * 4, glow: true });
      this.spawnParticles(f.x, f.y, 6 + Math.floor(prog * 8), "#d0a0ff", 80 + prog * 60, 0.35, { kind: "glow" });
    }
    else if (k === "swap_telegraph") {
      this.spawnShockwave(f.x, f.y, 48, "#a070e0", { life: 0.35, width: 3, glow: true });
    }
    else if (k === "selfhurt") { Sound.hit(); this.spawnParticles(f.x, f.y, 12, "#ff5d5d", 110, 0.4, { kind: "glow" }); }
    else if (k === "lightning") {
      Sound.castFor("lightning");
      this.spawnParticles(f.x, f.y, 12, "#aef2ff", 180, 0.3, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 34, "#aef2ff", { life: 0.22, width: 3 });
    }
    else if (k === "chain") {
      // an arc segment between two struck targets (or a fizzle to the aim point)
      Sound.castFor("lightning");
      this.spawnBeam(f.x, f.y, f.x2 || 0, f.y2 || 0, "#9fd0ff");
      this.spawnParticles(f.x2 || 0, f.y2 || 0, 8, "#cdeaff", 150, 0.3, { kind: "spark" });
    }
    else if (k === "chainheal") {
      Sound.castFor("sanctuary");
      this.spawnBeam(f.x, f.y, f.x2 || 0, f.y2 || 0, "#7ee8a0");
      this.spawnParticles(f.x2 || 0, f.y2 || 0, 8, "#c8ffd8", 120, 0.35, { kind: "glow" });
    }
    else if (k === "voidbeam") {
      Sound.castFor("voidbeam");
      this.spawnVoidBeam(f.x, f.y, f.x2 || 0, f.y2 || 0, f.v || 20);
      const mx = (f.x + (f.x2 || 0)) * 0.5, my = (f.y + (f.y2 || 0)) * 0.5;
      this.spawnParticles(mx, my, 10, "#12081c", 80, 0.5, { kind: "smoke", grav: -20, drag: 0.92 });
      this.spawnParticles(mx, my, 6, "#1e1428", 50, 0.35, { kind: "glow" });
    }
    else if (k === "absorb") {
      Sound.block();
      this.spawnParticles(f.x, f.y, 8, "#d9c2ff", 90, 0.35, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 30, "#c9a0ff", { life: 0.28, width: 2.5 });
    }
    else if (k === "reflect") {
      Sound.block();
      this.spawnParticles(f.x, f.y, 10, "#cdeaff", 140, 0.3, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 34, "#9fe7ff", { life: 0.26, width: 3 });
    }
    else if (k === "snarearm") { Sound.ui(); this.spawnShockwave(f.x, f.y, 72, "#b98bff", { life: 0.35, width: 3 }); }
    else if (k === "snarepop") { this.spawnParticles(f.x, f.y, 14, "#b98bff", 130, 0.5, { kind: "glow" }); }
    else if (k === "nullabsorb") { this.spawnParticles(f.x, f.y, 10, "#9ad4ff", 120, 0.35, { kind: "glow" }); }
    else if (k === "nullerupt") { this.commitNullSphereErupt(f.x, f.y, f.v || 280, 3); }
    else if (k === "voidriparm") {
      Sound.castFor("voidrip");
      this.spawnShockwave(f.x, f.y, 50, "#2a1840", { life: 0.4, width: 4, glow: false });
      this.spawnParticles(f.x, f.y, 10, "#12081c", 90, 0.45, { kind: "smoke", grav: -15, drag: 0.9 });
    }
    else if (k === "voidrippop") {
      Sound.endFor("voidrip");
      this.spawnParticles(f.x, f.y, 12, "#1e1428", 100, 0.4, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 88, "#2a1840", { life: 0.35, width: 2, glow: false });
    }
    else if (k === "hellriparm") {
      Sound.castFor("voidrip");
      const path = spellSfx("firewall").loop;
      if (path) Sound.startFirewallLoop(this.hrAudioKey({ x: f.x, y: f.y, arm: 0 }), path);
      this.spawnShockwave(f.x, f.y, 72, "#ff7a2f", { life: 0.45, width: 5 });
      this.spawnParticles(f.x, f.y, 16, "#ff7a2f", 180, 0.45, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 10, "#2a1810", 140, 0.4, { kind: "smoke", grav: 25, drag: 0.9 });
    }
    else if (k === "hellrippop") {
      Sound.stopFirewallLoop(this.hrAudioKey({ x: f.x, y: f.y, arm: 0 }));
      this.spawnParticles(f.x, f.y, 18, "#ff7a2f", 160, 0.5, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 96, "#ff5500", { life: 0.4, width: 3 });
    }
    else if (k === "voidglass_forge") {
      Sound.impactFor("meteor");
      this.spawnShockwave(f.x, f.y, f.v || 200, "#ff7a2f", { life: 0.5, width: 5 });
      this.spawnParticles(f.x, f.y, 20, "#ffb060", 200, 0.55, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 12, "#8fdcff", 140, 0.45, { kind: "glow" });
    }
    else if (k === "voidglass_shard") {
      this.spawnParticles(f.x, f.y, 10, "#e8fbff", 220, 0.35, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 6, "#8fdcff", 160, 0.3, { kind: "glow" });
    }
    else if (k === "voidglass_melt") {
      this.spawnParticles(f.x, f.y, 16, "#8fdcff", 80, 0.6, { kind: "glow", grav: 40, drag: 0.92 });
      this.spawnShockwave(f.x, f.y, f.v || 34, "#7ec8e8", { life: 0.55, width: 2, glow: false });
    }
    else if (k === "voidglass_crumble") {
      this.spawnParticles(f.x, f.y, 24, "#e8fbff", 160, 0.45, { kind: "spark", grav: 220, drag: 0.9 });
      this.spawnParticles(f.x, f.y, 18, "#ffb060", 120, 0.5, { kind: "glow", grav: 180, drag: 0.91 });
      this.spawnParticles(f.x, f.y, 12, "#8fdcff", 70, 0.65, { kind: "glow", grav: 60, drag: 0.94 });
      this.spawnShockwave(f.x, f.y, f.v || 34, "#9fd4f0", { life: 0.4, width: 2.5, glow: false });
    }
    else if (k === "judgment_cast") {
      Sound.castFor("fireball");
      this.spawnJudgmentNovaCharge(f.x, f.y, 0.05);
    }
    else if (k === "judgment_charge") {
      const prog = clamp((f.v || 0) / 100, 0, 1);
      this.spawnJudgmentNovaCharge(f.x, f.y, prog);
      if (prog > 0.35) {
        const secsLeft = (1 - prog) * Game.INFERNO_NOVA_WINDUP + Game.JUDGMENT_FUSE_DUR;
        Sound.nukeBeep(Math.ceil(secsLeft));
      }
    }
    else if (k === "arcane_orb") {
      this.spawnArcaneDetonationOrb(f.x, f.y, (f.v || 0) / 100);
    }
    else if (k === "arcane_detonation") {
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v || 100, {
        dur: 0.12,
        swamp: false,
        burstCount: 16,
        burstScale: 0.9,
        color: "#b060e8",
      });
    }
    else if (k === "judgment_fuse") {
      this.spawnMeteorNukeFuse(f.x, f.y, Game.JUDGMENT_FUSE_DUR);
    }
    else if (k === "nuke_beep") {
      Sound.nukeBeep(f.v || 1);
      this.pulseMeteorNukeFuse(f.x, f.y, f.v || 1);
      for (const o of this.arcaneDetonationOrbs || []) {
        if (Math.hypot(o.x - f.x, o.y - f.y) < 52) {
          o.flash = 1;
          o.tick = f.v || 1;
        }
      }
    }
    else if (k === "nuke_detonation") {
      Sound.nukeDetonation();
    }
    else if (k === "meteor_nuke_impact") {
      this.spawnMeteorNukeImpact(f.x, f.y, f.v || 400);
    }
    else if (k === "meteor_nuke") {
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v || this.meteorNukeShockwaveMaxR(f.x, f.y), { swamp: true });
      this.spawnFloorBurn("nuke", f.x, f.y, EXPLOSION_BURN.nuke.r);
    }
    else if (k === "judgment_nova") {
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v || this.meteorNukeShockwaveMaxR(f.x, f.y), {
        dur: 0.12,
        swamp: false,
        burstCount: 24,
        burstScale: 1.1,
      });
    }
    else if (k === "shatter_cast") {
      Sound.castFor("frostnova");
      this.spawnShockwave(f.x, f.y, 80, "#a8d4f0", { life: 0.35, width: 4 });
    }
    else if (k === "shatter_charge") {
      const prog = clamp((f.v || 0) / 100, 0, 1);
      this.spawnShockwave(f.x, f.y, 70 + prog * 140, "#9fe7ff", { life: 0.4, width: 4 + prog * 4 });
      this.spawnParticles(f.x, f.y, 8 + Math.floor(prog * 12), "#e8f4ff", 100 + prog * 80, 0.4, { kind: "glow" });
    }
    else if (k === "shatter_nova") {
      Sound.castFor("frostnova");
      this.spawnShockwave(f.x, f.y, 220, "#c8f0ff", { life: 0.45, width: 6 });
      this.spawnParticles(f.x, f.y, 24, "#e8f4ff", 180, 0.5, { kind: "spark" });
    }
    else if (k === "howling_gale") {
      tone(160, 0.55, { type: "sawtooth", gain: 0.05, slideTo: 95, channel: CH.sfx });
      this.spawnParticles(f.x, f.y, 22, "#b8e8ff", 220, 0.55, { kind: "glow", drag: 0.88 });
      this.spawnShockwave(f.x, f.y, 120, "#c8f0ff", { life: 0.35, width: 4, glow: true });
    }
    else if (k === "glacial_drift") {
      this.spawnShockwave(f.x, f.y, 110, "#9fe7ff", { life: 0.5, width: 3, glow: false });
    }
    else if (k === "frigid_well_cast") {
      Sound.castFor("frostnova");
      this.spawnShockwave(f.x, f.y, 90, "#ffc850", { life: 0.4, width: 5, glow: true });
      this.spawnParticles(f.x, f.y, 16, "#ffd878", 120, 0.45, { kind: "glow" });
    }
    else if (k === "frigid_well_ring") {
      this.spawnShockwave(f.x, f.y, f.v || 130, "#ffc850", { life: 0.6, width: 4, glow: true });
    }
    else if (k === "frigid_well_detonate" || k === "frigid_well_burst") {
      Sound.castFor("frostnova");
      const r = f.v || 130;
      this.spawnShockwave(f.x, f.y, r, "#ff9020", { life: 0.5, width: 7, glow: true });
      this.spawnParticles(f.x, f.y, 24, "#ffd878", 180 + r * 0.4, 0.55, { kind: "spark" });
    }
    else if (k === "lighthouse_charge") {
      const prog = clamp((f.v || 0) / 100, 0, 1);
      this.spawnParticles(f.x, f.y, 8 + prog * 10, "#ffd060", 90, 0.5, { kind: "glow", grav: 0, drag: 0.92 });
      this.spawnShockwave(f.x, f.y, 40 + prog * 60, "#ffc040", { life: 0.25, width: 2, glow: true });
    }
    else if (k === "lighthouse_sweep") {
      this.spawnShockwave(f.x, f.y, f.v || 400, "#ffc850", { life: 0.35, width: 3, glow: true });
      Sound.castFor("fireball");
    }
    else if (k === "void_bloom_charge") {
      this.spawnParticles(f.x, f.y, 14, "#6a38a8", 90, 0.5, { kind: "glow", grav: 0, drag: 0.9 });
      this.spawnShockwave(f.x, f.y, 60, "#9030c0", { life: 0.35, width: 3, glow: true });
    }
    else if (k === "void_bloom") {
      this.spawnShockwave(f.x, f.y, 110, "#8a3ad0", { life: 0.4, width: 3.5, glow: true });
      this.spawnParticles(f.x, f.y, 12, "#b060e6", 150, 0.45, { kind: "glow" });
      Sound.castFor("fireball");
    }
    else if (k === "mind_lash") {
      this.spawnShockwave(f.x, f.y, 180, "#8040b0", { life: 0.45, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 16, "#6a38a8", 140, 0.5, { kind: "glow" });
    }
    else if (k === "rift_collapse") {
      this.ixtholothRiftCollapsed = true;
      this.spawnShockwave(f.x, f.y, f.v || 400, "#4a1860", { life: 0.55, width: 5, glow: false });
      this.spawnParticles(f.x, f.y, 20, "#12081c", 160, 0.55, { kind: "smoke", grav: -12, drag: 0.9 });
    }
    else if (k === "dominate_telegraph") {
      this.spawnShockwave(f.x, f.y, 60, "#a050d0", { life: 0.35, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 12, "#8040b0", 110, 0.45, { kind: "glow" });
    }
    else if (k === "dominate") {
      this.spawnShockwave(f.x, f.y, 90, "#9030c0", { life: 0.4, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 14, "#6a38a8", 130, 0.5, { kind: "glow" });
    }
    else if (k === "proj_coll_shock") {
      Sound.boom();
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v || 100, {
        dur: 0.22,
        swamp: false,
        clearFuse: false,
        burstCount: 12,
        burstScale: 0.75,
      });
      this.spawnFloorBurn("projColl", f.x, f.y);
    }
    else if (k === "obstacle_scorch") {
      const fanArc = EXPLOSION_BURN.obstacle?.fanArc ?? 1.05;
      this.spawnFloorBurn("obstacle", f.x, f.y, f.v || 13, {
        fanA: f.a != null && Number.isFinite(f.a) ? f.a : 0,
        fanArc,
      });
    }
    else if (k === "comet_impact") {
      const rr = f.v || 200;
      Sound.impactFor("meteor");
      this.spawnShockwave(f.x, f.y, rr, "#9fe7ff", { life: 0.5, width: 7 });
      this.spawnShockwave(f.x, f.y, rr * 0.6, "#e8f8ff", { life: 0.32, width: 4 });
      this.spawnParticles(f.x, f.y, 22, "#aef0ff", 240, 0.5, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 14, "#d4f4ff", 180, 0.45, { kind: "glow" });
    }
    else if (k === "split") { Sound.hit(); this.spawnParticles(f.x, f.y, 12, "#ffd479", 180, 0.3, { kind: "spark" }); this.spawnShockwave(f.x, f.y, 28, "#ffe089", { life: 0.22, width: 3 }); }
    else if (k === "frost") { this.spawnParticles(f.x, f.y, 7, "#aef0ff", 150, 0.3, { kind: "spark" }); this.spawnShockwave(f.x, f.y, 22, "#9fe7ff", { life: 0.2, width: 2 }); }
    else if (k === "blizzard") {
      const r = f.v || 175;
      Sound.cast(520);
      this.spawnShockwave(f.x, f.y, r, "#9fe7ff", { life: 0.45, width: 3 });
      this.spawnParticles(f.x, f.y, 14, "#aef0ff", 220, 0.5, { kind: "spark" });
    }
    else if (k === "poison_pool") {
      const r = f.v || 85;
      this.spawnShockwave(f.x, f.y, r, "#6a8a30", { life: 0.5, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 12, "#c8d040", 140, 0.45, { kind: "glow" });
    }
    else if (k === "poison_pool_pulse") {
      const r = f.v || 85;
      this.spawnShockwave(f.x, f.y, r, "#c8d040", { life: 0.35, width: 2.5, glow: true });
    }
    else if (k === "contagion_mark" || k === "contagion_jump") {
      this.spawnParticles(f.x, f.y, 18, "#c8d040", 120, 0.55, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 40, "#6a8a30", { life: 0.45, width: 3, glow: true });
      if (k === "contagion_jump") {
        this.spawnShockwave(f.x, f.y, 90, "#c8d040", { life: 0.35, width: 2, glow: true });
      }
    }
    else if (k === "contagion_pop") {
      this.spawnParticles(f.x, f.y, 22, "#c8d040", 200, 0.6, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 70, "#6a8a30", { life: 0.5, width: 4, glow: true });
    }
    else if (k === "contagion_cleanse") {
      this.spawnParticles(f.x, f.y, 16, "#a8c860", 140, 0.55, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 55, "#6a8a30", { life: 0.4, width: 2.5, glow: true });
    }
    else if (k === "gorge_feed") {
      const stacks = f.v || 1;
      this.spawnShockwave(f.x, f.y, 55 + stacks * 4, "#6a8a30", { life: 0.45, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 14 + stacks, "#c8d040", 100, 0.5, { kind: "glow" });
    }
    else if (k === "trample_windup") {
      this.spawnShockwave(f.x, f.y, 48, "#6a8a30", { life: 0.35, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 10, "#4a2848", 80, 0.4, { kind: "glow" });
    }
    else if (k === "trample_impact") {
      const r = f.v || 70;
      this.spawnShockwave(f.x, f.y, r, "#6a8a30", { life: 0.5, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 20, "#c8d040", 220, 0.55, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 12, "#4a2848", 140, 0.45, { kind: "glow" });
    }
    else if (k === "plague_burst_cast") {
      Sound.castFor("fireball");
      this.spawnJudgmentNovaCharge(f.x, f.y, 0.05, "#6a8a30", "#c8d040");
    }
    else if (k === "plague_burst_charge") {
      const prog = clamp((f.v || 0) / 100, 0, 1);
      this.spawnJudgmentNovaCharge(f.x, f.y, prog, "#6a8a30", "#c8d040");
    }
    else if (k === "plague_burst_fuse") {
      this.spawnMeteorNukeFuse(f.x, f.y, Game.JUDGMENT_FUSE_DUR, "#6a8a30");
    }
    else if (k === "plague_burst") {
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v || this.meteorNukeShockwaveMaxR(f.x, f.y), {
        dur: 0.12,
        swamp: true,
        burstCount: 20,
        burstScale: 1.0,
        color: "#6a8a30",
      });
    }
    else if (k === "convergence_cast") {
      this.spawnShockwave(f.x, f.y, 120, "#e8b840", { life: 0.5, width: 4, glow: true });
      this.spawnShockwave(f.x, f.y, 90, "#8040a0", { life: 0.45, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 18, "#c8a0ff", 140, 0.5, { kind: "glow" });
    }
    else if (k === "essence_bloom_ripple") {
      this.spawnBloomRipple(f.x, f.y, f.v === 2 ? "void" : "light");
    }
    else if (k === "convergence_wave") {
      const wave = f.v || 1;
      const col = wave === 1 ? "#e8b840" : wave === 2 ? "#8040a0" : "#c8a0ff";
      const sub = wave === 1 ? "#ffd878" : wave === 2 ? "#4a1860" : "#f0e0ff";
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v2 || this.meteorNukeShockwaveMaxR(f.x, f.y), {
        dur: 0.14,
        swamp: false,
        burstCount: 28,
        burstScale: 1.15,
        color: col,
      });
      this.spawnShockwave(f.x, f.y, 280, sub, { life: 0.55, width: 6, glow: true });
      this.spawnParticles(f.x, f.y, 24, col, 200, 0.55, { kind: "glow" });
    }
    else if (k === "essence_meridian_snap") {
      const col = "#c8a0ff";
      this.spawnMeteorNukeShockwave(f.x, f.y, f.v2 || this.meteorNukeShockwaveMaxR(f.x, f.y), {
        dur: 0.16,
        swamp: false,
        burstCount: 32,
        burstScale: 1.2,
        color: col,
      });
      this.spawnShockwave(f.x, f.y, 320, "#e8b840", { life: 0.5, width: 5, glow: true });
      this.spawnShockwave(f.x, f.y, 320, "#8040a0", { life: 0.55, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 28, col, 220, 0.55, { kind: "glow" });
    }
    else if (k === "attunement_shift") {
      this.spawnShockwave(f.x, f.y, 200, "#c8a0ff", { life: 0.45, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 20, "#e8b840", 160, 0.5, { kind: "spark" });
      this.spawnParticles(f.x, f.y, 16, "#8040a0", 140, 0.45, { kind: "glow" });
    }
    else if (k === "essence_ward") {
      const col = f.v === 2 ? "#8040a0" : "#e8b840";
      this.spawnShockwave(f.x, f.y, 90, col, { life: 0.55, width: 4, glow: true });
      this.spawnParticles(f.x, f.y, 16, col, 120, 0.5, { kind: "glow" });
    }
    else if (k === "attune") {
      const me = this.human();
      const col = (me?.attuneToward || me?.essenceMark) === 1 ? "#e8b840" : "#8040a0";
      this.spawnShockwave(f.x, f.y, 42, col, { life: 0.35, width: 3, glow: true });
      this.spawnParticles(f.x, f.y, 10, col, 90, 0.45, { kind: "glow" });
    }
    else if (k === "push") { this.spawnShockwave(f.x, f.y, 145, "#a0ffd0", { life: 0.4, width: 6 }); this.spawnParticles(f.x, f.y, 14, "#a0ffd0", 160, 0.35, { kind: "glow" }); }
    else if (k === "blink") {
      Sound.blink();
      this.spawnParticles(f.x, f.y, 18, "#ffe089", 150, 0.4, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 36, "#ffe089", { life: 0.3, width: 3 });
    }
    else if (k === "illusion") {
      this.spawnParticles(f.x, f.y, 14, "#c9a0ff", 140, 0.45, { kind: "glow" });
      this.spawnShockwave(f.x, f.y, 36, "#c9a0ff", { life: 0.35, width: 2 });
    }
    else if (k === "illusionpop") {
      this.spawnParticles(f.x, f.y, 10, "#e8d4ff", 90, 0.35, { kind: "spark" });
      this.spawnShockwave(f.x, f.y, 28, "#c9a0ff", { life: 0.2, width: 1.5 });
    }
    else if (k && k.indexOf("impact:") === 0) {
      const id = k.slice(7);
      Sound.impactFor(id);
      const sp = spellInfo(id);
      const col = (sp && sp.color) || "#ffd0a0";
      const hitR = (sp && sp.radius) || 13;
      if (id === "boss_poison_spray") {
        this.natureBurst(f.x, f.y, 10, 0.85);
        this.spawnShockwave(f.x, f.y, 22, "#6a8a30", { life: 0.22, width: 2.5, glow: true });
      } else if (fireballSpriteFXEnabled(id)) {
        this.spawnSpellSpritePop(f.x, f.y, id, "impact", { worldR: hitR });
      } else {
        this.spawnParticles(f.x, f.y, 9, col, 150, 0.3, { kind: "spark" });
        this.spawnShockwave(f.x, f.y, 26, col, { life: 0.25, width: 3 });
      }
    }
    else if (k && k.indexOf("cast:") === 0) {
      const id = k.slice(5); const col = SPELLS[id] ? SPELLS[id].color : "#fff";
      if (fireballSpriteFXEnabled(id)) {
        Sound.castFor(id);
        this.spawnSpellSpritePop(f.x, f.y, id, "cast", { ang: this.castFXAim(f) });
      } else if (id === "glacier") {
        Sound.castFor("glacier");
      } else if (id === "firewall") {
        Sound.castFor("firewall");
        const path = spellSfx("firewall").loop;
        if (path) Sound.startFirewallLoop(`${Math.round(f.x)}:${Math.round(f.y)}`, path);
        this.spawnParticles(f.x, f.y, 14, "#2a1810", 200, 0.45, { kind: "smoke", grav: 35, drag: 0.9 });
        this.spawnParticles(f.x, f.y, 12, col, 160, 0.35, { kind: "spark" });
        this.spawnShockwave(f.x, f.y, 36, col, { life: 0.28, width: 6 });
        this.spawnShockwave(f.x, f.y, 18, "#ffd0a0", { life: 0.16, width: 3 });
      } else Sound.castFor(id);
      if (id !== "firewall" && !fireballSpriteFXEnabled(id)) {
        this.spawnParticles(f.x, f.y, 8, col, 110, 0.3, { kind: "glow" });
        this.spawnShockwave(f.x, f.y, 22, col, { life: 0.22, width: 2.5 });
      }
    }
  }

Game.prototype.syncPlayersFromSnapshot = function (wireById) {
    if (!wireById) return;
    if (!this.playerById) this.playerById = {};
    const entries = Array.isArray(wireById) ? wireById : Object.values(wireById);
    for (const w of entries) {
      if (!w || w.id == null) continue;
      const pid = w.id;
      if (this.playerById[pid]) continue;
      const isSelf = pid === this.myId;
      const p = new Player(isSelf ? 0 : 1, isSelf);
      p.id = pid;
      p.team = w.tm || 0;
      if (w.mir) {
        p.mirrorAdd = true;
        p.bossAdd = true;
        p.isBot = true;
        p.boss = w.bs || "";
        const dn = pveBossDisplayName(p.boss);
        p.name = dn;
        p.colorName = dn;
      } else if (w.bs) {
        p.boss = w.bs;
        p.name = pveBossDisplayName(w.bs);
        p.colorName = p.name;
      } else if (w.ad) {
        p.bossAdd = true;
        const dn = pveAddDisplayName(w.ak);
        p.name = dn;
        p.colorName = dn;
      } else if (p.team === 1) {
        p.name = isSelf ? "You" : "Ally";
        p.colorName = p.name;
      } else {
        p.name = "Enemy";
        p.colorName = "Enemy";
      }
      p.alive = true;
      this.players.push(p);
      this.playerById[pid] = p;
    }
  }

// Reuse an existing zone entry near (x,y), or null.
function interpFindNear(arr, x, y, eps, used) {
  for (let i = 0; i < arr.length; i++) {
    if (used.has(i)) continue;
    const p = arr[i];
    if (Math.abs(p.x - x) < eps && Math.abs(p.y - y) < eps) {
      used.add(i);
      return p;
    }
  }
  return null;
}

function projOwnerFromWire(b, sp) {
  if (b.o != null) return b.o;
  // Go omitempty drops o when caster id is 0; fall strikes always have an owner.
  return sp.fall ? 0 : null;
}

// Sync entity lists when a new snapshot arrives (~20 Hz). Reuses objects instead
// of allocating fresh arrays every snapshot pair (was ~20 full rebuilds/sec).
Game.prototype.syncInterpEntities = function (s0, s1, a, now) {
    const prevDc = this.decoys;
    const dcById = new Map();
    for (const d of prevDc) dcById.set(d.id, d);
    const nextDc = [];
    for (const id in s1.dc) {
      const b = s1.dc[id];
      let d = dcById.get(+id);
      if (!d) {
        const owner = this.playerById[b.o];
        d = {
          id: +id, ownerId: b.o, color: b.c, index: b.c,
          x: 0, y: 0, facing: 0, hp: b.hp,
          radius: CFG.playerRadius, scale: 1,
          robe: owner?.robe, trim: owner?.trim,
          detonateT: 0, suicide: false,
        };
      }
      d.color = b.c;
      d.index = b.c;
      d.hp = b.hp;
      nextDc.push(d);
    }
    this.decoys = nextDc;

    const prevPj = this.projectiles;
    const pjById = new Map();
    for (const pr of prevPj) pjById.set(pr.id, pr);
    const nextPj = [];
    for (const id in s1.pj) {
      const b = s1.pj[id];
      let pr = pjById.get(b.id);
      const sp = spellInfo(b.s) || { radius: 8, color: "#fff" };
      if (!pr) {
        pr = { id: b.id, x: 0, y: 0, radius: b.r || sp.radius, color: sp.color, spellId: b.s, prog: 0, ang: 0, nuke: !!b.nk, comet: !!b.cm, ownerId: projOwnerFromWire(b, sp) };
      } else {
        pr.spellId = b.s;
        pr.color = sp.color;
        pr.radius = b.r || sp.radius;
        pr.nuke = !!b.nk;
        pr.comet = !!b.cm;
        pr.ownerId = projOwnerFromWire(b, sp);
      }
      nextPj.push(pr);
    }
    this.projectiles = nextPj;

    const wireMn = s1.mn || [];
    const nextMn = [];
    for (let i = 0; i < wireMn.length; i++) {
      const m = wireMn[i];
      let old = this.mines[i];
      if (!old || old.x !== m.x || old.y !== m.y) old = null;
      nextMn.push(old
        ? Object.assign(old, { arm: m.a ? 0 : 1, pulse: now })
        : { x: m.x, y: m.y, arm: m.a ? 0 : 1, pulse: now });
    }
    this.mines = nextMn;

    const prevSg = this.sigils;
    const usedSg = new Set();
    const nextSg = [];
    for (const g of (s1.sg || [])) {
      let old = prevSg.find(p => g.s === p.spellId && Math.hypot(p.x - g.x, p.y - g.y) < 4);
      if (old) usedSg.add(old);
      const arm = g.ar != null ? g.ar : (g.a ? 0 : 1);
      nextSg.push(old
        ? Object.assign(old, { x: g.x, y: g.y, r: g.r, arm, life: g.l, spellId: g.s, pulse: now, nullSphere: !!g.ns, consumed: g.nc || 0 })
        : { x: g.x, y: g.y, r: g.r, arm, life: g.l, spellId: g.s, pulse: now, nullSphere: !!g.ns, consumed: g.nc || 0, fillStars: null });
    }
    this.sigils = nextSg;

    const prevHp = this.healpods;
    const s0hp = s0.hp || [];
    const nextHp = [];
    for (const h of (s1.hp || [])) {
      const old = prevHp.find(p => Math.hypot(p.x - h.x, p.y - h.y) < 6);
      const pa = s0hp.find(p => Math.hypot(p.x - h.x, p.y - h.y) < 6);
      const pg = pa ? lerp(pa.pg || 0, h.pg || 0, a) : (h.pg || 0);
      nextHp.push(healPodFromWire({ x: h.x, y: h.y, r: h.r, pg, tm: h.tm }, now, old));
    }
    for (const old of prevHp) {
      if (nextHp.some(p => Math.hypot(p.x - old.x, p.y - old.y) < 6)) continue;
      this.commitBloomPodDetonate(old.x, old.y, old.r || 120);
    }
    this.healpods = nextHp;

    const prevNse = this.nullSphereErupts || [];
    const usedNse = new Set();
    const nextNse = [];
    for (const e of (s1.nse || [])) {
      const old = prevNse.find(p => Math.hypot(p.x - e.x, p.y - e.y) < 6);
      if (old) usedNse.add(old);
      const pa = (s0.nse || []).find(p => Math.hypot(p.x - e.x, p.y - e.y) < 6);
      const life = pa ? lerp(pa.l ?? 0, e.l ?? 0, a) : (e.l ?? 0);
      nextNse.push(old
        ? Object.assign(old, { x: e.x, y: e.y, r: e.r, life, total: e.tl ?? 3, consumed: e.nc || 0, pulse: now })
        : { x: e.x, y: e.y, r: e.r, life, total: e.tl ?? 3, consumed: e.nc || 0, pulse: now });
    }
    this.nullSphereErupts = nextNse;

    const bb0 = s0.bb || [];
    const usedPrev = new Set();
    const prevBb = this.bossBeams || [];
    const nextBb = [];
    for (let i = 0; i < (s1.bb || []).length; i++) {
      const b = s1.bb[i];
      const slot = b.sl != null ? b.sl : i;
      let pa = bb0.find(p => p.sl === slot);
      if (!pa) {
        let bestIdx = -1, bestD = Infinity;
        for (let j = 0; j < bb0.length; j++) {
          if (usedPrev.has(j)) continue;
          const d = Math.abs(angleDiff(bb0[j].an, b.an));
          if (d < bestD) { bestD = d; bestIdx = j; }
        }
        if (bestIdx >= 0 && bestD < Math.PI * 0.75) {
          usedPrev.add(bestIdx);
          pa = bb0[bestIdx];
        } else {
          pa = bb0[i];
        }
      }
      const ang = pa ? angLerp(pa.an, b.an, a) : b.an;
      const old = prevBb.find(p => p.slot === slot);
      nextBb.push(old
        ? Object.assign(old, {
          x: b.x, y: b.y, angle: ang, slot,
          halfW: b.hw, inner: b.in, reach: b.re,
          warnLead: b.wl, warnW: b.ww, armT: b.ar, life: b.l, spellId: b.s,
        })
        : {
          x: b.x, y: b.y, angle: ang, slot,
          halfW: b.hw, inner: b.in, reach: b.re,
          warnLead: b.wl, warnW: b.ww, armT: b.ar, life: b.l, spellId: b.s,
        });
    }
    this.bossBeams = nextBb;

    const prevBz = this.blizzards;
    const usedBz = new Set();
    const nextBz = [];
    for (let i = 0; i < (s1.bz || []).length; i++) {
      const b = s1.bz[i];
      let old = (prevBz[i] && !usedBz.has(i) && Math.abs(prevBz[i].x - b.x) < 4 && Math.abs(prevBz[i].y - b.y) < 4) ? prevBz[i] : null;
      if (!old) old = interpFindNear(prevBz, b.x, b.y, 4, usedBz);
      const meteorShower = !!b.ms;
      const keepFX = old && this.blizzardFXContinues(old, b);
      nextBz.push(old
        ? Object.assign(old, {
          x: b.x, y: b.y, r: b.r, life: b.l, meteorShower, ownerId: b.o ?? 0, pulse: now,
          shards: keepFX ? (old.shards || []) : [],
          windParts: keepFX ? (old.windParts || []) : [],
          _spawnAcc: keepFX ? (old._spawnAcc || 0) : 0,
          _windAcc: keepFX ? (old._windAcc || 0) : 0,
        })
        : {
          x: b.x, y: b.y, r: b.r, life: b.l, meteorShower, ownerId: b.o ?? 0, pulse: now,
          shards: [], windParts: [], _spawnAcc: 0, _windAcc: 0,
        });
    }
    this.blizzards = nextBz;

    const prevPp = this.poisonPools || [];
    const usedPp = new Set();
    const nextPp = [];
    const nextIds = new Set();
    for (let i = 0; i < (s1.pp || []).length; i++) {
      const b = s1.pp[i];
      const key = `${Math.round(b.x)}:${Math.round(b.y)}`;
      nextIds.add(key);
      let old = (prevPp[i] && !usedPp.has(i) && Math.abs(prevPp[i].x - b.x) < 4 && Math.abs(prevPp[i].y - b.y) < 4) ? prevPp[i] : null;
      if (!old) old = interpFindNear(prevPp, b.x, b.y, 4, usedPp);
      nextPp.push(old
        ? Object.assign(old, { x: b.x, y: b.y, r: b.r, life: b.l, arm: b.ar || 0, pulse: now })
        : { x: b.x, y: b.y, r: b.r, life: b.l, arm: b.ar || 0, pulse: now });
    }
    for (const pool of prevPp) {
      const key = `${Math.round(pool.x)}:${Math.round(pool.y)}`;
      if (!nextIds.has(key) && pool.arm <= 0 && pool.r > 20) {
        this.spawnPlagueStain(pool.x, pool.y, pool.r * 0.85);
      }
    }
    this.poisonPools = nextPp;

    const prevFw = this.firewalls;
    const usedFw = new Set();
    const nextFw = [];
    for (let i = 0; i < (s1.fw || []).length; i++) {
      const w = s1.fw[i];
      let old = (prevFw[i] && !usedFw.has(i) && Math.abs(prevFw[i].x - w.x) < 4 && Math.abs(prevFw[i].y - w.y) < 4) ? prevFw[i] : null;
      if (!old) old = interpFindNear(prevFw, w.x, w.y, 4, usedFw);
      nextFw.push(old
        ? Object.assign(old, { x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l, pulse: now })
        : { x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l, pulse: now, born: now, emberParts: [], _emberAcc: 0 });
    }
    this.syncFirewallLoopAudio(prevFw, nextFw);
    this.firewalls = nextFw;

    const prevHr = this.hellrips;
    const usedHr = new Set();
    const nextHr = [];
    for (let i = 0; i < (s1.hr || []).length; i++) {
      const h = s1.hr[i];
      let old = (prevHr[i] && !usedHr.has(i) && Math.abs(prevHr[i].x - h.x) < 4 && Math.abs(prevHr[i].y - h.y) < 4) ? prevHr[i] : null;
      if (!old) old = interpFindNear(prevHr, h.x, h.y, 4, usedHr);
      nextHr.push(old
        ? Object.assign(old, { x: h.x, y: h.y, r: h.r, rot: h.rt, arm: h.ar || 0, life: h.l, pulse: now })
        : { x: h.x, y: h.y, r: h.r, rot: h.rt, arm: h.ar || 0, life: h.l, pulse: now, born: now, fillStars: null, emberParts: [], _emberAcc: 0, _ringEmberAcc: 0 });
    }
    this.syncHellRipLoopAudio(prevHr, nextHr);
    this.hellrips = nextHr;

    const prevSm = this.stickymines;
    const usedSm = new Set();
    const nextSm = [];
    for (let i = 0; i < (s1.sm || []).length; i++) {
      const h = s1.sm[i];
      let old = (prevSm[i] && !usedSm.has(i) && Math.abs(prevSm[i].x - h.x) < 4 && Math.abs(prevSm[i].y - h.y) < 4) ? prevSm[i] : null;
      if (!old) old = interpFindNear(prevSm, h.x, h.y, 4, usedSm);
      nextSm.push(old
        ? Object.assign(old, { x: h.x, y: h.y, r: h.r, chase: !!h.ch, fuse: h.fu || 0, life: h.li || 0, ti: h.ti, pulse: now })
        : { x: h.x, y: h.y, r: h.r, chase: !!h.ch, fuse: h.fu || 0, life: h.li || 0, ti: h.ti, pulse: now, beepAt: 0 });
    }
    this.syncStickyMineFuseAudio(prevSm, nextSm);
    this.stickymines = nextSm;

    const prevIw = this.icewalls;
    const usedIw = new Set();
    const nextIw = [];
    for (let i = 0; i < (s1.iw || []).length; i++) {
      const w = s1.iw[i];
      let old = (prevIw[i] && !usedIw.has(i) && Math.abs(prevIw[i].x - w.x) < 4 && Math.abs(prevIw[i].y - w.y) < 4) ? prevIw[i] : null;
      if (!old) old = interpFindNear(prevIw, w.x, w.y, 4, usedIw);
      nextIw.push(old
        ? Object.assign(old, { x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l, pulse: now })
        : { x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l, pulse: now, born: now, _shardAcc: 0 });
    }
    this.icewalls = nextIw;

    const prevVg = this.voidglass || [];
    const usedVg = new Set();
    const nextVg = [];
    for (let i = 0; i < (s1.vg || []).length; i++) {
      const v = s1.vg[i];
      let old = (prevVg[i] && !usedVg.has(i) && Math.abs(prevVg[i].x - v.x) < 4 && Math.abs(prevVg[i].y - v.y) < 4) ? prevVg[i] : null;
      if (!old) old = interpFindNear(prevVg, v.x, v.y, 4, usedVg);
      const newH = v.h || 0;
      const oldH = old?.h || 0;
      let twirlVel = old?._twirlVel || 0;
      let twirlAng = old?._twirlAng || 0;
      if (old && newH > oldH && v.ph === 1) {
        const dx = v.x - old.x;
        const dy = v.y - old.y;
        const move = Math.hypot(dx, dy);
        const sign = (newH % 2 === 0) ? 1 : -1;
        twirlVel = sign * (5.5 + Math.min(move * 0.06, 4));
        twirlAng = old._twirlAng || 0;
      }
      nextVg.push(old
        ? Object.assign(old, {
          x: v.x, y: v.y, dx: v.dx, dy: v.dy, hx: v.hx, hy: v.hy, r: v.r,
          ph: v.ph != null ? v.ph : 0, arm: v.ar, h: newH, life: v.l, pulse: now,
          _twirlVel: twirlVel, _twirlAng: twirlAng,
        })
        : {
          x: v.x, y: v.y, dx: v.dx, dy: v.dy, hx: v.hx, hy: v.hy, r: v.r,
          ph: v.ph != null ? v.ph : 0, arm: v.ar, h: newH, life: v.l, pulse: now,
          born: now, _shardAcc: 0, _sparkAcc: 0, _twirlVel: twirlVel, _twirlAng: twirlAng,
        });
    }
    this.voidglass = nextVg;

    const prevIp = this.icePatches || [];
    const usedIp = new Set();
    const nextIp = [];
    const nextIpIds = new Set();
    for (let i = 0; i < (s1.ip || []).length; i++) {
      const ip = s1.ip[i];
      const key = `${Math.round(ip.x)}:${Math.round(ip.y)}`;
      nextIpIds.add(key);
      let old = (prevIp[i] && !usedIp.has(i) && Math.abs(prevIp[i].x - ip.x) < 4 && Math.abs(prevIp[i].y - ip.y) < 4) ? prevIp[i] : null;
      if (!old) old = interpFindNear(prevIp, ip.x, ip.y, 4, usedIp);
      nextIp.push(old
        ? Object.assign(old, { x: ip.x, y: ip.y, r: ip.r, arm: ip.ar || 0, life: ip.l, spellId: ip.s, pulse: now })
        : { x: ip.x, y: ip.y, r: ip.r, arm: ip.ar || 0, life: ip.l, spellId: ip.s, pulse: now });
    }
    for (const ip of prevIp) {
      const key = `${Math.round(ip.x)}:${Math.round(ip.y)}`;
      if (!nextIpIds.has(key) && ip.arm <= 0 && ip.r > 20) {
        this.spawnFrostStain(ip.x, ip.y, ip.r * 0.82);
      }
    }
    this.icePatches = nextIp;
    let iceDirty = (prevIp || []).length !== nextIp.length;
    if (!iceDirty) {
      for (let i = 0; i < nextIp.length; i++) {
        const a = prevIp[i], b = nextIp[i];
        if (!a || Math.abs(a.x - b.x) > 0.5 || Math.abs(a.y - b.y) > 0.5 || Math.abs(a.r - b.r) > 0.5 ||
            (a.arm || 0) !== (b.arm || 0) || Math.abs((a.life || 0) - (b.life || 0)) > 0.05 ||
            a.spellId !== b.spellId) {
          iceDirty = true;
          break;
        }
      }
    }
    if (iceDirty) this.icePatchesDirty = true;

    const prevWf = this.windFields || [];
    const usedWf = new Set();
    const nextWf = [];
    for (let i = 0; i < (s1.wf || []).length; i++) {
      const wf = s1.wf[i];
      let old = (prevWf[i] && !usedWf.has(i) && Math.abs(prevWf[i].x - wf.x) < 4 && Math.abs(prevWf[i].y - wf.y) < 4) ? prevWf[i] : null;
      if (!old) old = interpFindNear(prevWf, wf.x, wf.y, 4, usedWf);
      const pa = (s0.wf || []).find(p => Math.abs(p.x - wf.x) < 4 && Math.abs(p.y - wf.y) < 4);
      const ang = pa ? angLerp(pa.an, wf.an, a) : wf.an;
      nextWf.push(old
        ? Object.assign(old, { x: wf.x, y: wf.y, angle: ang, halfW: wf.hw, life: wf.l, spellId: wf.s, pulse: now })
        : { x: wf.x, y: wf.y, angle: ang, halfW: wf.hw, life: wf.l, spellId: wf.s, pulse: now });
    }
    this.windFields = nextWf;

    const prevSr = this.soakRings || [];
    const usedSr = new Set();
    const nextSr = [];
    const s0sr = s0.sr || [];
    for (let i = 0; i < (s1.sr || []).length; i++) {
      const sr = s1.sr[i];
      let old = (prevSr[i] && !usedSr.has(i) && Math.abs(prevSr[i].x - sr.x) < 4 && Math.abs(prevSr[i].y - sr.y) < 4) ? prevSr[i] : null;
      if (!old) old = interpFindNear(prevSr, sr.x, sr.y, 4, usedSr);
      const pa = s0sr.find(p => Math.abs(p.x - sr.x) < 4 && Math.abs(p.y - sr.y) < 4);
      const fuse = pa ? lerp(pa.f, sr.f, a) : sr.f;
      const fuseMax = sr.fm || pa?.fm || fuse;
      nextSr.push(old
        ? Object.assign(old, { x: sr.x, y: sr.y, r: sr.r, fuse, fuseMax, spellId: sr.s, pulse: now })
        : { x: sr.x, y: sr.y, r: sr.r, fuse, fuseMax, spellId: sr.s, pulse: now });
    }
    this.soakRings = nextSr;

    const prevFs = this.fissures || [];
    const usedFs = new Set();
    const nextFs = [];
    for (let i = 0; i < (s1.fs || []).length; i++) {
      const fs = s1.fs[i];
      let old = (prevFs[i] && !usedFs.has(i) && Math.abs(prevFs[i].x - fs.x) < 4 && Math.abs(prevFs[i].y - fs.y) < 4) ? prevFs[i] : null;
      if (!old) old = interpFindNear(prevFs, fs.x, fs.y, 4, usedFs);
      const pa = (s0.fs || []).find(p => Math.abs(p.x - fs.x) < 4 && Math.abs(p.y - fs.y) < 4);
      const ang = pa ? angLerp(pa.an, fs.an, a) : fs.an;
      const front = pa ? lerp(pa.fr, fs.fr, a) : fs.fr;
      nextFs.push(old
        ? Object.assign(old, { x: fs.x, y: fs.y, angle: ang, front, halfW: fs.hw, len: fs.ln, life: fs.l, spellId: fs.s, pulse: now })
        : { x: fs.x, y: fs.y, angle: ang, front, halfW: fs.hw, len: fs.ln, life: fs.l, spellId: fs.s, pulse: now });
    }
    this.fissures = nextFs;

    const prevEw = this.essenceWards || [];
    const nextEw = [];
    for (let i = 0; i < (s1.ew || []).length; i++) {
      const ew = s1.ew[i];
      let old = (prevEw[i] && Math.abs(prevEw[i].x - ew.x) < 4 && Math.abs(prevEw[i].y - ew.y) < 4) ? prevEw[i] : null;
      if (!old) old = prevEw.find(p => Math.abs(p.x - ew.x) < 4 && Math.abs(p.y - ew.y) < 4);
      nextEw.push(old
        ? Object.assign(old, { x: ew.x, y: ew.y, r: ew.r, mark: ew.m, pulse: now })
        : { x: ew.x, y: ew.y, r: ew.r, mark: ew.m, pulse: now });
    }
    this.essenceWards = nextEw;

    this.essenceCast = s1.ec || null;

    if (s1.pa) for (let i = 0; i < this.pillars.length && i < s1.pa.length; i++) {
      const pa = !!s1.pa[i];
      if (this.pillars[i].active !== pa) { this.pillars[i].active = pa; this.pillarsDirty = true; }
    }
  }

Game.prototype.lerpInterpEntities = function (s0, s1, a, now, extrapMs, span) {
    for (const pr of this.projectiles) {
      const b = s1.pj[pr.id], pa = s0.pj[pr.id];
      if (!b) continue;
      if (pa && extrapMs > 0 && span > 0) {
        const vx = (b.x - pa.x) / span;
        const vy = (b.y - pa.y) / span;
        pr.x = b.x + vx * extrapMs;
        pr.y = b.y + vy * extrapMs;
        pr.ang = Math.atan2(vy, vx);
      } else if (pa) {
        pr.x = lerp(pa.x, b.x, a);
        pr.y = lerp(pa.y, b.y, a);
        pr.ang = Math.atan2(b.y - pa.y, b.x - pa.x);
      } else {
        pr.x = b.x; pr.y = b.y;
      }
      if (pa && b.pg != null) pr.prog = lerp(pa.pg || 0, b.pg || 0, a);
      else if (b.pg != null) pr.prog = b.pg || 0;
    }
    for (const d of this.decoys) {
      const b = s1.dc[d.id], pa = s0.dc[d.id] || b;
      if (!b) continue;
      const scale0 = (pa.sc != null && pa.sc > 0) ? pa.sc : 1;
      const scale1 = (b.sc != null && b.sc > 0) ? b.sc : 1;
      const scale = lerp(scale0, scale1, a);
      d.x = lerp(pa.x, b.x, a);
      d.y = lerp(pa.y, b.y, a);
      d.facing = angLerp(pa.a, b.a, a);
      d.hp = b.hp;
      d.scale = scale;
      d.radius = CFG.playerRadius * scale;
      d.detonateT = b.dt || 0;
      d.suicide = scale < 0.99 || (b.dt > 0);
    }
    const hpW = s1.hp || [], hp0 = s0.hp || [];
    for (let i = 0; i < this.healpods.length && i < hpW.length; i++) {
      const pod = this.healpods[i], w = hpW[i], pa = hp0[i];
      const pg = pa ? lerp(pa.pg || 0, w.pg || 0, a) : (w.pg || 0);
      Object.assign(pod, healPodFromWire({ x: w.x, y: w.y, r: w.r, pg, tm: w.tm }, now, pod));
    }
    const nseW = s1.nse || [], nse0 = s0.nse || [];
    for (let i = 0; i < this.nullSphereErupts.length && i < nseW.length; i++) {
      const e = this.nullSphereErupts[i], w = nseW[i], pa = nse0[i];
      e.life = pa ? lerp(pa.l ?? 0, w.l ?? 0, a) : (w.l ?? 0);
    }
    for (const m of this.mines) m.pulse = now;
    for (const g of this.sigils) g.pulse = now;
    for (const bz of this.blizzards) bz.pulse = now;
    for (const fw of this.firewalls) fw.pulse = now;
    for (const hr of this.hellrips) hr.pulse = now;
    for (const sm of this.stickymines) sm.pulse = now;
    for (const iw of this.icewalls) iw.pulse = now;
    for (const v of this.voidglass) v.pulse = now;
    for (const e of this.nullSphereErupts) e.pulse = now;
  }

Game.prototype.interpolate = function () {
    const buf = this.snaps;
    if (buf.length === 0) return;
    const renderT = this.now - this.interpDelay;
    let s0 = buf[0], s1 = buf[buf.length - 1];
    let bracketed = false;
    for (let i = 0; i < buf.length - 1; i++) {
      if (buf[i].recv <= renderT && buf[i + 1].recv >= renderT) {
        s0 = buf[i]; s1 = buf[i + 1]; bracketed = true; break;
      }
    }
    if (!bracketed && renderT > s1.recv && buf.length >= 2) {
      s0 = buf[buf.length - 2];
      s1 = buf[buf.length - 1];
    }
    const span = s1.recv - s0.recv;
    const a = span > 0 ? clamp((renderT - s0.recv) / span, 0, 1) : (renderT >= s1.recv ? 1 : 0);
    const extrapMs = renderT > s1.recv ? Math.min(renderT - s1.recv, EXTRAP_CAP_MS) : 0;
    const now = this.nowS;

    this.syncPlayersFromSnapshot(s1.p);
    const pr0 = (s0.pr > 0) ? s0.pr : (this.maxRadius || CFG.worldRadius);
    const pr1 = (s1.pr > 0) ? s1.pr : pr0;
    this.platformRadius = lerp(pr0, pr1, a);

    for (const p of this.players) {
      const b = s1.p[p.id];
      if (!b) continue;
      const pa = s0.p[p.id] || b;
      let x = lerp(pa.x, b.x, a);
      let y = lerp(pa.y, b.y, a);
      if (extrapMs > 0 && !p.isHuman && span > 0) {
        x += ((b.x - pa.x) / span) * extrapMs;
        y += ((b.y - pa.y) / span) * extrapMs;
      }
      p.x = x;
      p.y = y;
      if (extrapMs > 0 && !p.isHuman && span > 0) {
        p.facing = b.a + (angleDiff(pa.a, b.a) / span) * extrapMs;
      } else {
        p.facing = angLerp(pa.a, b.a, a);
      }
      if (b.am != null) {
        const prevAim = pa.am != null ? pa.am : pa.a;
        p.aim = angLerp(prevAim, b.am, a);
      }
      p.hp = b.hp;
      if (b.mhp) p.maxHP = b.mhp;
      if (b.cr) p.collR = b.cr;
      if (b.coy) p.collOffY = b.coy;
      p.alive = b.al;
      p.falling = b.fl;
      p.fallT = b.ft;
      p.shieldT = b.sh ? 1 : 0;
      p.absorbT = b.ba ? 1 : 0;
      p.reflectT = b.rf ? 1 : 0;
      p.outside = b.out;
      p.invisT = b.iv ? 1 : 0;
      p.root = b.rt ? 1 : 0;
      p.rootSpell = b.rs || "";
      p.channelSpell = b.cs || "";
      p.pendingSpell = b.pw || "";
      p.silence = b.si ? 1 : 0;
      p.freeze = b.fz ? 1 : 0;
      p.slowT = b.sl ? 1 : 0;
      p.rushT = b.ru ? 1 : 0;
      if (b.ts) {
        p.tshiftT = 1;
        p._tsGhost = { x: b.tx, y: b.ty, a: b.ta != null ? b.ta : b.a };
      } else {
        p.tshiftT = 0;
        p._tsGhost = null;
      }
      p.enraged = !!b.rg;
      if (b.bs !== undefined) p.boss = b.bs || "";
      if (b.ad !== undefined) p.bossAdd = !!b.ad;
      p.blinkVuln = !!b.bv;
      p.mirrorAdd = !!b.mir;
      p.contagion = !!b.cg;
      p.gorgeStacks = b.gs || 0;
      p.addKind = b.ak || "";
      if (p.mirrorAdd && p.boss) {
        p.isBot = true;
        const dn = pveBossDisplayName(p.boss);
        p.name = dn;
        p.colorName = dn;
      } else if (b.ad && b.ak) {
        const dn = pveAddDisplayName(b.ak);
        p.name = dn;
        p.colorName = dn;
      }
      p.castLabel = b.bl || "";
      p.dashSpell = b.ds || "";
      p.stun = b.st ? 1 : 0;
      p.burnT = b.bn ? 1 : 0;
      p.hemorrhageT = b.hm ? 1 : 0;
      p.exhaustionT = b.ex ? 1 : 0;
      p.mindLashT = b.ml || 0;
      p.mindCtrlT = b.mc || 0;
      p.tetherBy = (b.te != null && b.te >= 0) ? this.playerById[b.te] : null;
      p.channelProg = b.cp || 0;
      p.castPose = b.qp || 0;
      if (p.castPose > 0 && p.boss) touchBossCast(p.boss);
      if (b.tm != null) p.team = b.tm;
      p.wins = b.wn || 0;
      p.kills = b.ko || 0;
      p.deaths = b.de || 0;
      p.dmgDealt = b.dd || 0;
      p.dmgTaken = b.dt || 0;
      p.healDone = b.hl || 0;
      p.dcGone = !!b.dg;
      p.dcGrace = b.dc > 0;
      if (b.dm != null) p.dummy = !!b.dm;
      if (b.sd != null) p.dumbEnemy = !!b.sd;
      p.essenceMark = b.em || 0;
      p.attuneProg = b.ap || 0;
      p.attuneToward = b.am || 0;
      if (b.dc > 0) {
        p.dcLeft = b.dc;
        p.dcLeftAt = s1.recv;
      } else {
        p.dcLeft = 0;
        p.dcLeftAt = 0;
      }
    }

    if (s1.recv !== this._interpSnapRecv) {
      this._interpSnapRecv = s1.recv;
      this.syncInterpEntities(s0, s1, a, now);
    }
    this.lerpInterpEntities(s0, s1, a, now, extrapMs, span);
  }

Game.prototype.fwAudioKey = function (w) {
    return `${Math.round(w.x)}:${Math.round(w.y)}`;
  }

Game.prototype.stickyMineAudioKey = function (sm) {
    return `${Math.round(sm.x)}:${Math.round(sm.y)}`;
  }

Game.prototype.syncStickyMineFuseAudio = function (prevSm, nextSm) {
    const prevChase = new Set((prevSm || []).filter(sm => sm.chase).map(sm => this.stickyMineAudioKey(sm)));
    const now = performance.now();
    for (const sm of nextSm || []) {
      if (!sm.chase || sm.fuse <= 0) continue;
      const key = this.stickyMineAudioKey(sm);
      if (!prevChase.has(key)) {
        Sound.stickyMineBeep(0);
        sm.beepAt = now;
        continue;
      }
      const fuseMax = 2.0;
      const urgency = 1 - clamp(sm.fuse / fuseMax, 0, 1);
      const interval = Math.max(110, 420 * (1 - urgency * 0.72));
      if (now - (sm.beepAt || 0) >= interval) {
        Sound.stickyMineBeep(urgency);
        sm.beepAt = now;
      }
    }
  }

Game.prototype.syncFirewallLoopAudio = function (prevFw, nextFw) {
    const path = spellSfx("firewall").loop;
    if (!path) return;
    const prev = prevFw || [];
    const next = nextFw || [];
    if (prev.length === next.length && prev.every((w, i) => {
      const n = next[i];
      return n && w.x === n.x && w.y === n.y && w.dx === n.dx && w.dy === n.dy;
    })) return;
    const prevKeys = new Set(prev.map(w => this.fwAudioKey(w)));
    for (const w of next) {
      const k = this.fwAudioKey(w);
      if (!prevKeys.has(k)) Sound.startFirewallLoop(k, path);
    }
    for (const k of prevKeys) {
      if (!next.some(w => this.fwAudioKey(w) === k)) Sound.stopFirewallLoop(k);
    }
  }

Game.prototype.resetWalkBobTrackers = function () {
    for (const p of this.players) { delete p._bx; delete p._by; }
    for (const d of this.decoys || []) { delete d._bx; delete d._by; }
  }

Game.prototype.updateRemote = function (dt) {
    if (this.state === "lobby" || this.state === "menu" || this.state === "matchover") return;
    this._frameDt = dt;
    tickInterpDelay(this, dt);
    this.interpolate();
    if (this.inSpectateView()) this.ensureAliveSpectateTarget();
    this.tickRoundSpectate();
    const h = this.human();
    if (h && h.alive && !h.falling) {
      // aim follows the cursor (used for casting + replicated for spectators)
      const o = this.castOrigin(h);
      h.aim = this.aimTowardCursor(o.x, o.y).a;
      if (this.net) this.sendAimMaybe(h.aim);
    }
    this.tickHoldMove();
    this.predictSelf(dt);
    this.updateSpriteOctants(dt);
    this.updateCamera(dt);
    this.updateSpriteTrails(dt);
    this.updateFloorBurns(dt);
    this.updateBloodStains(dt);
    this.updatePlagueStains(dt);
    this.updateFrostStains(dt);
    this.updateMeteorNukeFuses(dt);
    this.updateArcaneDetonationOrbs(dt);
    this.updateMeteorNukeSwamps(dt);
    this.updateMeteorNukeClouds(dt);
    this.updateBlizzardShards(dt);
    this.updateBlizzardWind(dt);
    this.updateFireWallEmbers(dt);
    this.updateHellRipEmbers(dt);
    this.updateIceWallCollapse(dt);
    if (this.updateVoidglassFX) this.updateVoidglassFX(dt);
    this.updateParticles(dt);
    this.updateArmPops(dt);
    this.updateSpellSpritePops(dt);
    this.updateColossusChargeTrails(dt);
  }

Game.prototype.clearMoveTarget = function () {
    const pr = this.pred;
    if (pr) pr.moveTarget = null;
    const h = this.human();
    if (h) h.moveTarget = null;
    if (this.simReady && typeof wsimClearMove === "function") wsimClearMove();
  }

Game.prototype.bossBeamSpinAngle = function (p) {
    if (!p.alive || p.falling) return null;
    // Ix'tholoth's eye has no beam — it simply tracks the server facing.
    if (p.boss === "ixtholoth") return p.facing ?? Math.PI / 2;
    if (p.boss !== "aurelion") return null;
    const beams = this.bossBeams;
    if (beams?.length) {
      let pick = beams.find(b => b.slot === 0);
      if (!pick) pick = beams[0];
      return pick.angle ?? null;
    }
    if (p.channelSpell === "boss_lighthouse_sweep") return p.facing;
    return p.facing ?? Math.PI / 2;
  }

Game.prototype.updateSpriteOctants = function (dt) {
    const minStep = (Math.PI / 4) / CFG.faceTurnRate;
    for (const p of this.players) {
      if (!p.alive || p.falling) continue;
      const spin = this.bossBeamSpinAngle(p);
      if (spin != null) {
        p.beamSpin = spin;
        p._spriteOctAcc = 0;
        continue;
      }
      const target = octIndex(p.facing);
      if (p.pendingSpell || p.channelSpell || p.castPose > 0) {
        p.spriteOct = target;
        p._spriteOctAcc = 0;
        continue;
      }
      if (p.spriteOct == null) { p.spriteOct = target; p._spriteOctAcc = 0; continue; }
      if (p.spriteOct === target) { p._spriteOctAcc = 0; continue; }
      p._spriteOctAcc = (p._spriteOctAcc || 0) + dt;
      while (p._spriteOctAcc >= minStep && p.spriteOct !== target) {
        p._spriteOctAcc -= minStep;
        let diff = target - p.spriteOct;
        while (diff > 4) diff -= 8;
        while (diff < -4) diff += 8;
        if (diff === 0) break;
        p.spriteOct = (p.spriteOct + (diff > 0 ? 1 : -1) + 8) % 8;
      }
    }
  }

Game.prototype.playerWalkBob = function (p) {
    if (p.falling) return false;
    if (p.boss === "aurelion") return false;
    if (p.boss === "ixtholoth") return false;
    const sp = len(p.x - (p._bx ?? p.x), p.y - (p._by ?? p.y));
    p._bx = p.x; p._by = p.y;
    const frameDt = Math.max(this._frameDt || 1 / 60, 1 / 240);
    const minSp = 35 * frameDt;
    if (sp < minSp) return false;
    if ((p.knockT || 0) > 0) return false;
    let moving = true;
    if (p.isHuman && this.pred?.init && this.simReady) {
      const pr = this.pred;
      // WASM hasMove is authoritative for click-to-move, but reconcile clears it
      // on pending/channel snapshots while velocity still carries the wizard — fall
      // back to prediction velocity + move target (knockback already gated above).
      moving = !!pr.hasMove;
      if (!moving) {
        const v = len(pr.vx || 0, pr.vy || 0);
        if (v > 30) moving = true;
        else if (pr.moveTarget) {
          const dx = pr.moveTarget.x - p.x, dy = pr.moveTarget.y - p.y;
          if (len(dx, dy) > CFG.arriveRadius) {
            const moveAng = Math.atan2(dy, dx);
            if (Math.abs(angleDiff(p.facing, moveAng)) <= CFG.moveAlignAngle + 1e-4) moving = true;
          }
        }
      }
    }
    return moving;
  }

Game.prototype.predictSelf = function (dt) {
    const h = this.human();
    const pr = this.pred;
    if (!h || !pr.init || !this.simReady) return;
    if (!pr.alive || pr.falling) return;
    if (h.mindCtrlT > 0) return;
    if (this.pillarsDirty) this.syncSimPillars(); // only re-push when pillars actually change
    if (this.icePatchesDirty) this.syncSimIcePatches();
    if (typeof wsimSetPlatform === "function") wsimSetPlatform(this.platformRadius);
    if (typeof wsimSetAim === "function") wsimSetAim(h.aim);
    const r = wsimStep(dt);
    if (!r) return;
    h.x = r.x; h.y = r.y;
    h.facing = r.facing;
    h.moveTarget = r.hasMove ? pr.moveTarget : (this._holdMoveActive ? pr.moveTarget : null);
    pr.x = r.x; pr.y = r.y; pr.vx = r.vx; pr.vy = r.vy;
    pr.hasMove = !!r.hasMove;
    if (!r.hasMove && !this._holdMoveActive) pr.moveTarget = null;
  }

Game.prototype.initSim = function () {
    if (typeof Go === "undefined" || typeof WebAssembly === "undefined") {
      console.warn("WASM unavailable; local wizard will render from snapshots only");
      return;
    }
    const go = new Go();
    window.onWarlocksSimReady = () => {
      this.simReady = true;
      this.pillarsDirty = true;
      // Snapshots may have arrived before WASM finished loading; replay so
      // prediction (and hasMove walk-bob) works without a full page reload.
      if (this._lastReconcile && typeof wsimReconcile === "function") {
        wsimReconcile(this._lastReconcile);
      }
      this.resetWalkBobTrackers();
    };
    const url = assetURL("dist/warlocks.wasm") + "?v=" + (window.WLK_V || "1");
    fetch(url)
      .then(r => r.arrayBuffer())
      .then(buf => WebAssembly.instantiate(buf, go.importObject))
      .then(res => go.run(res.instance))
      .catch(err => { console.warn("failed to load prediction sim:", err); this.simReady = false; });
  }

Game.prototype.syncSimPillars = function () {
    if (!this.simReady || typeof wsimSetPillars !== "function") return; // stay dirty until the sim is ready
    const flat = [];
    for (const pl of this.pillars) flat.push(pl.x, pl.y, pl.r, pl.active ? 1 : 0);
    wsimSetPillars(flat);
    this.pillarsDirty = false;
  }

Game.prototype.syncSimIcePatches = function () {
    if (!this.simReady || typeof wsimSetIcePatches !== "function") return;
    const flat = [];
    for (const ip of this.icePatches || []) {
      if (ip.arm > 0) continue;
      flat.push(ip.x, ip.y, ip.r, ip.arm || 0, ip.life || 0);
    }
    wsimSetIcePatches(flat);
    this.icePatchesDirty = false;
  }

Game.prototype.aimTowardCursor = function (px, py) {
    const m = this.screenToWorld(this.mouse.x, this.mouse.y);
    return { a: Math.atan2(m.y - py, m.x - px), d: Math.hypot(m.x - px, m.y - py) };
  }

Game.prototype.castOrigin = function (p) {
    if (p && p.isHuman && this.pred.init && this.simReady) return { x: this.pred.x, y: this.pred.y };
    return { x: p.x, y: p.y };
  }

Game.prototype.sendAimMaybe = function (aim) {
    const now = performance.now();
    const interval = this.chargingSlot ? 33 : 60;
    if (now - this._lastAimSent > interval) {
      this._lastAimSent = now;
      if (this.net) this.net.send({ t: "aim", a: aim });
    }
  }

// Hold LMB to move: local target updates every frame; server move msgs throttled
// (~12.5 Hz, on par with aim) so 8 humans holding in one room ≈ 100 small WS msgs/s.
Game.MOVE_SEND_MS = 80;
Game.MOVE_SEND_EPS = 5;

Game.prototype.tickHoldMove = function (force) {
    if (!this._holdMoveActive || !this.mouse.down) return;
    if (this.state !== "playing" || this.sandboxShopOpen || this.sandboxDraftOpen || this.slotDrag) return;
    const p = this.human();
    if (!p || !p.alive || p.falling) return;

    const w = this.screenToWorld(this.mouse.x, this.mouse.y);
    const pr = this.pred;
    if (pr) pr.moveTarget = w;
    p.moveTarget = w;
    if (this.simReady && typeof wsimSetMove === "function") wsimSetMove(w.x, w.y);

    const now = performance.now();
    if (!force) {
      if (now - (this._lastMoveSent || 0) < Game.MOVE_SEND_MS) return;
      if (this._lastMoveX != null && len(w.x - this._lastMoveX, w.y - this._lastMoveY) < Game.MOVE_SEND_EPS) return;
    }
    this._lastMoveSent = now;
    this._lastMoveX = w.x;
    this._lastMoveY = w.y;
    if (this.net) this.net.send({ t: "move", x: w.x, y: w.y });
  }

Game.prototype.buildMenu = function () {
    const seg = document.getElementById("playerCount");
    if (!seg) return;
    seg.innerHTML = "";
    const botCount = clamp(this.numPlayers - 1, 1, 7);
    for (let bots = 1; bots <= 7; bots++) {
      const b = document.createElement("button");
      b.textContent = bots;
      if (bots === botCount) b.classList.add("active");
      b.onclick = () => {
        this.numPlayers = bots + 1;
        [...seg.children].forEach(c => c.classList.remove("active"));
        b.classList.add("active");
      };
      seg.appendChild(b);
    }
  }

Game.prototype.human = function () { return this.players.find(p => p.isHuman); }

Game.prototype.screenToWorld = function (sx, sy) { return { x: (sx - this.cx) / this.scale + this.camX, y: (sy - this.cy) / this.scaleY + this.camY }; }

// Counteract the oblique ground foreshortening so a sprite drawn after this call
// renders at its true (top-down) aspect ratio. Apply right after translating to
// the sprite's world anchor and before any local rotation. Things that genuinely
// lie on the floor (AoE zones, shadows, telegraph rings) must NOT call this.
Game.prototype.upright = function () { this.ctx.scale(1, this.scale / this.scaleY); }

Game.prototype.sprite = function (p) {
    if (!this.sprites[p.robe]) this.sprites[p.robe] = makeWizardSprite(p.robe, p.trim);
    return this.sprites[p.robe];
  }

Game.prototype.grad = function (key, build) {
    let g = this._gradCache.get(key);
    if (g === undefined) { g = build(this.ctx); this._gradCache.set(key, g); }
    return g;
  }

// Gradients built at identity transform so they reuse across translated draws.
Game.prototype.gradLocal = function (key, build) {
    let g = this._gradCache.get(key);
    if (g === undefined) {
      if (!this._gradScratch) {
        this._gradScratch = document.createElement("canvas");
        this._gradScratch.width = this._gradScratch.height = 1;
      }
      const gc = this._gradScratch.getContext("2d");
      gc.setTransform(1, 0, 0, 1, 0, 0);
      g = build(gc);
      this._gradCache.set(key, g);
    }
    return g;
  }
